
import Vue from 'vue'
import { VRadio } from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcRadioInput',
  components: { VRadio },
  props: {
    required: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    label: { type: String, required: true },
    value: { type: [String, Number], required: true },
    groupLabel: { type: String, default: '' },
  },
})
